import React from 'react';
import { IconWrapper } from '../runtime';
export default IconWrapper('arrow-left-one', false, function (props) {
  return /*#__PURE__*/React.createElement("svg", {
    width: props.size,
    height: props.size,
    viewBox: "0 0 128 128"
  }, /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    strokeWidth: "1",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(64.000000, 64.000000) rotate(-180.000000) translate(-64.000000, -64.000000) translate(-0.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M36.4322325,17.389005 C38.0085897,15.6374971 40.5817561,15.3166737 42.5180172,16.5125199 L43.2110693,17.0322241 L91.2110282,60.2321869 C93.094249,61.927086 93.3034962,64.740273 91.8387678,66.6836806 L91.2110282,67.3678045 L43.2110693,110.567768 C41.2406229,112.341169 38.2056343,112.181433 36.4322325,110.210987 C34.8558754,108.459479 34.806936,105.866851 36.1994292,104.066818 L36.7890133,103.432149 L80.8192061,63.7903957 L36.7890133,24.1678417 C35.0375055,22.5914846 34.7166821,20.0183182 35.9125283,18.0820571 L36.4322325,17.389005 Z",
    fill: props.colors[0],
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("rect", {
    x: "0",
    y: "0",
    width: "128",
    height: "128"
  }))));
});